<template>
  <li :class="`locale-table-item ${isLocal ? 'locale-table-item_local' : ''}`"
      @mouseover="mouseOver"
      @mouseleave="mouseLeave">
    <div class="wrapper">

      <div class="locale-table-item-infos-active">
        <app-toggle v-show="isLocal"
                    class="locale-table-item-infos-active-toggle"
                    v-model="isActive"
                    @input="toogleStatus"></app-toggle>
      </div>
      <div class="locale-table-item-infos"
           @click.stop="toogleNode">

        <span class="label">
          <i v-if="node.hasChildren"
             :class="`mdi ${hasChildIcon}`"></i>

          <template v-if="isAparelho">
            <svgicon :icon="typeIcon"
                     width="30"
                     height="30"
                     color="gray"
                     v-if="isActiveNull"
                     v-tooltip="'Sem acessos'"></svgicon>
            <svgicon :icon="typeIcon"
                     width="30"
                     height="30"
                     color="#ffcc00"
                     v-else-if="!nodeData.isAtivo"
                     v-tooltip="'Sem acesso a mais de 2 Dias'"></svgicon>
            <svgicon :icon="typeIcon"
                     width="30"
                     height="30"
                     color="green"
                     v-else-if="nodeData.isAtivo"
                     v-tooltip="'Acesso executado nos últimos 2 dias'"></svgicon>
          </template>
          <template v-else-if="isLocalGroup">
            <svgicon :icon="typeIcon"
                     width="20"
                     height="20"
                     color="#707070"></svgicon>
          </template>
          <i v-else
             :class="`mdi ${typeIcon}`"></i>
          <!-- <p></p> -->
          <span>{{ nodeData.nome }}</span>
          <button
            v-if="isAparelho && nodeData.chave"
            class="node-key-local"
            @click="copyKey"
        >
            <span>{{ nodeData.chave }}</span>
            <i
                class="mdi node-key-local-icon pointer"
                :class="{
                    'mdi-check': isKeyCopied,
                    'mdi-content-copy': !isKeyCopied,
                }"></i>
        </button>
        </span>

        <div v-if="gerenciarLocal || isMaster"
             class="locale-table-item-infos-actions">
          <template v-if="!isAparelho">
            <i class="mdi mdi-square-edit-outline pointer"
               v-tooltip="$t('message.generics.message.edit')"
               @click.stop="edit(node)">
            </i>

            <!-- <template v-if="isLocal">
              <i class="mdi mdi-airplay pointer"
                 v-tooltip="'Tipo de login'"
                 @click.stop="updateLoginTypes"></i>
            </template> -->

            <span class="locale-table-item-infos-actions-add">
              <i class="mdi mdi-plus-circle-outline pointer"
                 v-tooltip="$t('message.generics.message.add')"
                 @click.stop="toogleSelect"></i>

              <div class="select"
                   ref="select"
                   v-if="isSelectOpen">
                <template v-if="isLocalGroup">
                  <div @click.stop="showLocalsGroupCreationModal = true">
                    {{$t('message.spots.message.newGroup')}}
                  </div>
                  <div @click.stop="showLocalsCreationModal = true">
                    {{$t('message.spots.message.newSpot')}}
                  </div>
                </template>

                <template v-if="isLocal">
                  <div @click.stop="showAccessPointGroupModal = true">
                    {{$t('message.spots.message.newGroup')}}
                  </div>
                  <div @click.stop="showUserDeviceModal = true">
                    {{$t('message.spots.message.newDevice')}}
                  </div>
                </template>

                <template v-if="isGrupoDeAcesso">
                  <div @click.stop="showAccessPointGroupModal = true">
                    {{$t('message.spots.message.newGroup')}}
                  </div>
                  <div @click.stop="showUserDeviceModal = true">
                    {{$t('message.spots.message.newDevice')}}
                  </div>
                </template>
              </div>
            </span>
          </template>

          <template v-if="isAparelho">
            <i class="mdi mdi-square-edit-outline pointer"
               v-tooltip="$t('message.generics.message.edit')"
               @click.stop="edit(node)">
            </i>

            <i class="mdi mdi-settings pointer"
               v-tooltip="$t('message.generics.message.advancedSettings')"
               @click.stop="settings"></i>

            <i v-if="isTrial && isMikrotik"
               class="mdi mdi-login pointer"
               v-tooltip="'Simular Acesso'"
               @click.stop="redirectToCaptivePortal"></i>            

            <i class="mdi mdi-cloud-download pointer"
               v-tooltip="$t('message.spots.message.downloadConfigFiles')"
               @click.stop="downloadConfigFiles"></i>

          </template>

          <template v-if="isAdmin && isLocal">
            <!-- <i class="mdi mdi-cellphone-nfc pointer"
               v-tooltip="'Ativar WiFeed'"
               @click.stop="activateWifeed"></i>

            <i class="mdi mdi-cellphone-off pointer"
               v-tooltip="'Desativar WiFeed'"
               @click.stop="() => showIncativateWifeedModal = true"></i>

            <i class="mdi mdi-wifi pointer"
               v-tooltip="'IP\'s liberados'"
               @click.stop="releasedIps"></i>-->

          </template>

          <i class="mdi mdi-close-circle-outline"
             v-tooltip="$t('message.generics.message.delete')"
             @click.stop="() => showDeleteConfirmModal = true"></i>

        </div>
      </div>

      <LocalsCreationModal v-if="showLocalsCreationModal"
                           :node="node"
                           v-model="showLocalsCreationModal"
                           @created="setNode" />

      <LocalsGroupCreationModal v-if="showLocalsGroupCreationModal"
                                :node="node"
                                v-model="showLocalsGroupCreationModal"
                                @created="setNode" />

      <AccessPointGroupModal v-if="showAccessPointGroupModal"
                             :node="node"
                             v-model="showAccessPointGroupModal"
                             @created="setNode" />

      <UserDeviceModal v-if="showUserDeviceModal"
                       :node="node"
                       v-model="showUserDeviceModal"
                       @created="setNode" />

      <ConfirmationModal v-if="showIncativateWifeedModal"
                         :value="showIncativateWifeedModal"
                         :confirm-label="$t('message.generics.message.confirm')"
                         @confirm="deactivateWifeed"
                         @cancel="() => showIncativateWifeedModal = false">
        <span slot="heading">
          {{$t('message.spots.message.disableWifeed')}}
        </span>
        <span>
          {{$t('message.spots.message.disableWifeedConfirmation')}}
        </span>
      </ConfirmationModal>

      <ConfirmationModal v-if="showDeleteConfirmModal"
                         :value="showDeleteConfirmModal"
                         :confirm-label="$t('message.generics.message.confirm')"
                         @confirm="deleteNode"
                         @cancel="() => showDeleteConfirmModal = false">
        <span slot="heading">
          {{$t('message.generics.message.delete')}} {{ node.tipo | nodeType }}
        </span>
        <span>
          {{$t('message.spots.message.deleteThis')}} {{ node.tipo | nodeType }}? {{$t('message.spots.message.actionIrreversible')}}
        </span>
      </ConfirmationModal>
    </div>

    <div class="load-more"
         v-if="node.hasMore">
      <button class="btn btn-extra-round"
              @click.stop="loadMore">
          {{$t('message.spots.message.loadMore')}}
      </button>
    </div>

  </li>
</template>

<script>
import Vue from "vue";
import ConfirmationModal from "@components/ConfirmationModal";
import LocalsGroupCreationModal from "@views/locals/components/LocalsGroupCreationModal";
import LocalsCreationModal from "@views/locals/components/LocalsCreationModal";
import AccessPointGroupModal from "@views/locals/components/AccessPointGroupModal";
import UserDeviceModal from "@views/devices/UserDeviceModal";
import AppToggle from "@components/Toggle";
import EventBus from "@packages/event-bus/index";

export default {
  props: {
    node: {
      type: Object,
    },
  },

  components: {
    UserDeviceModal,
    AppToggle,
    AccessPointGroupModal,
    LocalsGroupCreationModal,
    LocalsCreationModal,
    ConfirmationModal,
  },

  watch: {
    node: function (newVal) {
      this.nodeData = {
        ...this.nodeData,
        ...newVal,
      };
    },
  },
  created() {
    EventBus.$on("LOAD_MORE", this.loadMoreHandler);
    EventBus.$on("UPDATE_NODE", this.updateNodeHandler);
    EventBus.$on("OPEN_NODE", this.openNodeHandler);
    EventBus.$on("CLOSE_ITEM_SELECT", this.closeSelect);
    document.addEventListener("click", this.closeSelectOnClick);
  },

  beforeDestroy() {
    EventBus.$off("LOAD_MORE", this.loadMoreHandler);
    EventBus.$off("UPDATE_NODE", this.updateNodeHandler);
    EventBus.$off("CLOSE_ITEM_SELECT", this.closeSelect);
    EventBus.$off("OPEN_NODE", this.openNodeHandler);
    document.removeEventListener("click", this.closeSelectOnClick);
  },

  data() {
    return {
      isOpen: false,
      nodeData: { ...this.node },
      isSelectOpen: false,
      showDeleteConfirmModal: false,
      isActive: this.node.isAtivo,
      page: 0,
      opening: false,
      showIncativateWifeedModal: false,
      showUserDeviceModal: false,
      showAccessPointGroupModal: false,
      showLocalsCreationModal: false,
      showLocalsGroupCreationModal: false,
      isKeyCopied: false,
    };
  },

  mixins: [],

  computed: {
    isActiveNull() {
      return this.nodeData.isAtivo === null;
    },
    isAdmin() {
      return !!this.$store.state.users.admin;
    },
    permissions() {
      return this.$store.state.users.user.permissions;
    },
    gerenciarLocal() {
      return this.permissions.find((x) => x === "MANAGE_LOCALS") ? true : false;
    },
    isMaster() {
      return this.permissions.includes("MASTER");
    },
    isLocal() {
      return this.nodeData.tipo === "LOCAL";
    },
    isLocalGroup() {
      return this.nodeData.tipo === "GRUPO_LOCAL";
    },
    isAparelho() {
      return this.nodeData.tipo === "APARELHO";
    },
    isGrupoDeAcesso() {
      return this.nodeData.tipo === "GRUPO_PONTO_ACESSO";
    },
    hasChildIcon() {
      return this.isOpen ? "mdi-chevron-down" : "mdi-chevron-right";
    },
    typeIcon() {
      let icon = "";

      if (this.isGrupoDeAcesso) {
        icon = "mdi-folder-outline";
      } else if (this.isLocal) {
        icon = "mdi-map-marker-outline";
      } else if (this.isLocalGroup) {
        icon = "folder-marker-outline";
      } else if (this.isAparelho) {
        icon = "access-point";
      }

      return icon;
    },
    userId() {
      return this.$store.state.users.user.id;
    },
    isTrial() {
      return process.env.NODE_ENV === "trial"
    },
    isMikrotik() {
      return (this.isAparelho && this.node.showConfig)
    }
  },

  methods: {
    async activateWifeed() {
      await this.$api.locals.activateWifeed({
        id: this.nodeData.id,
      });
    },
    async deactivateWifeed() {
      await this.$api.locals.deactivateWifeed({
        id: this.nodeData.id,
      });
    },

    copyKey() {
        navigator.clipboard.writeText(this.nodeData.chave);
        this.isKeyCopied = true;
        setTimeout(() => {
            this.isKeyCopied = false;
        }, 2000);
    },
    releasedIps() {
      EventBus.$emit("RESET_RELESEAD_IPS", this.nodeData);
    },
    mouseOver() {
      this.$emit("mouseover", this.node.level);
    },
    mouseLeave() {
      this.$emit("mouseleave", this.node.level);
    },
    loadMoreHandler({ id, type }) {
      if (this.node.id === id && this.node.tipo === type) {
        this.loadChildren();
      }
    },
    addChildrenHandler({ id, type, newNodes }) {
      if (this.node.id === id && this.node.type === type) {
        this.node.children.push(newNodes);
      }
    },
    async updateLoginTypes() {
      EventBus.$emit("UPDATE_LOGIN_TYPES", {
        id: this.nodeData.id,
        name: this.nodeData.nome,
        userId: this.userId,
      });
    },
    async openNodeHandler({ id, type }) {
      if (this.node.id === id && this.node.tipo === type) {
        this.openNode();
      }
    },
    updateNodeHandler(updatedNode) {
      if (
        updatedNode.id === this.nodeData.id &&
        updatedNode.tipo === this.nodeData.tipo
      ) {
        this.nodeData = {
          ...this.nodeData,
          ...updatedNode,
        };
      }
    },
    async downloadConfigFiles() {
      const file = await this.fetchConfigFile();
      const link = this.createElement(file);
      link.click();
    },
    async fetchConfigFile() {
      return this.$api.devices.configFile({ id: this.nodeData.id });
    },
    createElement(file) {
      const url = window.URL.createObjectURL(new Blob([file]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "configuracao.zip");
      document.body.appendChild(link);
      return link;
    },   
    settings() {
      let params = {};
      params.id = this.node.id;
      params.name = this.node.nome;
      EventBus.$emit("EDIT_DEVICE_SETTINGS", params);
    },
    setNode(newNode) {
      this.$emit('reloadDeviceCount')

      this.closeSelect();

      if (!this.isOpen) return;

      newNode.identifier = `${newNode.tipo}-${newNode.id}`;

      this.$emit("pushChild", {
        id: this.node.id,
        type: this.node.tipo,
        newNode,
      });
    },
    async loadMore() {
      this.node.hasMore = false;
      EventBus.$emit("LOAD_MORE", {
        id: this.node.parent.id,
        type: this.node.parent.type,
      });
    },
    async loadChildren() {
      try {
        this.opening = true;

        let newNodes = await this.$api.localeManagement.openNode({
          nodeId: this.node.id,
          type: this.node.tipo,
          page: this.page,
        });
        // console.log("newNodes", newNodes)

        this.page++;

        newNodes = newNodes.map((node) => {
          return {
            ...node,
            identifier: `${node.tipo}-${node.id}`,
            children: [],
          };
        });

        const lastItem = newNodes[newNodes.length - 1];

        if (lastItem) {
          lastItem.parent = {
            id: this.node.id,
            type: this.node.tipo,
          };
          lastItem.hasMore = newNodes.length === 50;
        }

        if (this.node.children) {
          this.node.children.push(...newNodes);
        } else {
          Vue.set(this.node, "children", newNodes);
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.opening = false;
      }
    },
    async toogleNode() {
      if (!this.isAparelho) {
        if (!this.isOpen) {
          if (!this.opening) {
            this.openNode();
          }
        } else {
          this.closeNode();
        }
      }

      this.closeSelect();
    },
    async openNode() {
      this.page = 0;
      Vue.set(this.node, "children", []);
      await this.loadChildren();
      this.isOpen = true;
    },
    closeNode() {
      Vue.set(this.node, "children", []);
      this.isOpen = false;
    },
    edit(node) {
      const data = node || this.node;

      this.$emit("edit", { id: data.id, tipo: data.tipo });
    },
    toogleSelect() {
      EventBus.$emit("CLOSE_ITEM_SELECT");
      this.isSelectOpen = !this.isSelectOpen;
    },
    closeSelect() {
      this.isSelectOpen = false;
    },
    closeSelectOnClick(e) {
      if (
        this.$refs.select &&
        !this.$refs.select.contains(e.target) &&
        e.target.className !== "vld-background" &&
        e.target.tagName !== "BODY"
      ) {
        this.closeSelect();
      }
    },
    addNewGroup() {
      EventBus.$emit("ADD_GROUP_LOCAL", this.node);
    },
    addNewAccesPointGroup() {
      EventBus.$emit("ADD_ACCESS_GROUP", this.node);
    },
    updateNode(updatedNode) {
      this.nodeData = {
        ...this.nodeData,
        ...updatedNode,
      };
    },
    async deleteNode() {
      EventBus.$emit("SHOW_SPINNER");

      try {
        switch (this.node.tipo) {
          case "LOCAL":
            await this.$api.locals.delete({ id: this.node.id });
            break;
          case "GRUPO_LOCAL":
            await this.$api.localeGroup.delete({ id: this.node.id });
            break;
          case "APARELHO":
            await this.$api.devices.delete({ id: this.node.id });
            break;
          case "GRUPO_PONTO_ACESSO":
            await this.$api.accessPointGroup.delete({ id: this.node.id });
            break;
          default:
            break;
        }

        this.$emit("deleted", { id: this.node.id, type: this.node.tipo });
        this.$emit('reloadDeviceCount')
        EventBus.$emit("show-message", {
          type: "SUCCESS",
          message: this.$t('message.successMessages.message.elementDeleted'),
        });
      } catch (error) {
        console.log(error);
      } finally {
        this.showDeleteConfirmModal = false;
        EventBus.$emit("CANCEL_SPINNER");
      }
    },
    async toogleStatus() {
      await this.$api.locals.status({
        id: this.node.id,
      });
    },
    async redirectToCaptivePortal() {    
      try {
        const url = await this.$api.devices.getCaptiveRedirectUrl(this.node.id);
       if(url) {
        window.open('https://' + url, '_blank')
       }
      } catch (error) {
         EventBus.$emit("show-message", {
          type: "ERROR",
          message: "Ocorreu um erro ao simular o acesso.",
        });
      } 
    }
  },
};
</script>

<style lang="scss" scoped>
@import "~@variables";

.locale-table-item {
  color: #707070;

  .load-more {
    flex-basis: 100%;
    display: flex;
    justify-content: center;

    .btn {
      color: $blue-primary;
    }
  }

  .wrapper {
    cursor: pointer;
    position: relative;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #c8c8c8;
    flex-wrap: wrap;

    .locale-table-item-infos-active {
      padding: 0 24px;
      width: 94px;
      display: flex;
      align-items: center;

      .v-input {
        display: none;

        >>> .v-input__slot {
          margin: 0 !important;
        }
      }
    }

    &:hover {
      background: #eee;
    }

    .locale-table-item-infos {
      flex: 1;
      display: flex;
      align-items: center;
      height: 55px;
      user-select: none;

      .label {
        padding: 0 24px;
        display: flex;
        align-items: center;

        font-weight: 500;

        p {
          margin: 0;
        }

        i,
        .svg-icon {
          display: flex;
          align-items: center;
          font-size: 20px;
          text-align: center;
          width: 20px;
          height: 20px;
          margin-right: 5px;
        }
      }

      .locale-table-item-infos-actions {
        padding: 0 24px;
        margin-left: auto;

        i {
          margin-right: 5px;
        }

        .locale-table-item-infos-actions-add {
          position: relative;

          .select {
            width: 150px;
            position: absolute;
            top: 70%;
            right: 50%;
            transform: translateX(50%);
            z-index: 1;
            padding: 10px 20px;
            background-color: $white;
            border-radius: 20px;
            border: 1px solid $grey-2;

            font-size: 14px;
            font-weight: 500;

            div {
              margin-bottom: 5px;

              &:hover {
                font-weight: 600;
              }
            }
          }
        }
      }
    }

    ul {
      margin: 6px 0;

      &.dragging {
        margin-left: 20px;
        margin-top: -1px;
        border: 1px dashed gray;
        width: 100%;
        min-height: 30px;
      }
    }

    &.locale-table-item_local {
      .locale-table-item-infos {
        .locale-table-item-infos-active {
          .v-input {
            display: block;
          }
        }
      }
    }
  }

  .node-key-local {
        margin-left: 8px;
        background-color: $grey-1;
        border-radius: 4px;
        gap: 4px;
        padding: 4px 0px 4px 4px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 12px;

        .node-key-local-icon::before {
            font-size: 12px;
            width: 100%;
        }
    }
}
</style>
